import React from 'react';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'services/i18n';

import { StyledButton, StyledIcon } from 'components/widgets/customerSupport/sharedStyle';
import { IconName } from 'components/core/Icon/Icon';
import { isMobileNotSdkSelector } from 'redux/selectors/global';
import { hideModal, showModal } from 'redux/actions/global';
import { getHostedPageFlowType } from 'utilities/global';
import { Tracker } from 'shared/services/tracking';
import MODAL_TYPES from 'components/containers/Modal/Modals/types';
import { ThemeFamilies } from 'models';
import { GA_ACTIONS, GA_LABEL } from 'consts';

interface IProps {
  phoneNumber: string;
}

const CustomerSupportPhoneNumber = ({ phoneNumber }: IProps) => {
  const dispatch = useDispatch();
  const isMobile = useSelector(isMobileNotSdkSelector);

  const tracker = new Tracker(getHostedPageFlowType());

  const handlePhoneClick = () => {
    tracker.fireEvent({
      category: `${GA_ACTIONS.CUSTOMER_SUPPORT} - ${GA_LABEL.PHONE}`,
      action: GA_ACTIONS.CUSTOMER_SUPPORT
    });

    if (isMobile) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      const subTitle = (
        <Trans
          i18nKey="customerSupport.call_us_subtitle"
          values={{
            phoneNumber
          }}
        />
      );

      dispatch(
        showModal({
          type: MODAL_TYPES.CTA,
          props: {
            generalProps: {
              name: 'call-us-modall',
              title: i18n.t('customerSupport.call_us'),
              subTitle,
              primaryButtonProps: {
                children: `${i18n.t('cancel')}`,
                onClick: () => dispatch(hideModal())
              }
            }
          }
        })
      );
    }
  };

  return (
    <StyledButton themeFamily={ThemeFamilies.BORDERED_PRIMARY} onClick={handlePhoneClick}>
      <StyledIcon name={IconName.PHONE} />
    </StyledButton>
  );
};

export default CustomerSupportPhoneNumber;
